import React, { FC, Fragment, useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { Form, Row, Col, Divider, Space, Button, InputNumber, Typography } from 'antd'
import useFetchSetting from "../../../../hooks/useFetchSetting"
import PrefixService from "../../../../services/prefix"
import PatternNumber from '../../../../utils/PatternNumber'
import { PointCalurateSetting } from '../../../../@types/prefix'
import FormattedMessage from '../../../../components/Elements/FormattedMessage'
import { FuncFormattedMessage } from '../../../../utils/FuncFormattedMessage'

interface PointProps {
    setActiveKey: (key: string) => void
    setIsUpdate: (isUpdate: boolean) => void
}


const Point: FC<PointProps> = ({ setActiveKey, setIsUpdate }) => {

    const [form] = Form.useForm();
    const { data: dataSetting } = useFetchSetting()

    const [btnLoading, setBtnLoading] = useState<boolean>(false)
    const updateData = async (values: PointCalurateSetting) => {
        try {
            const res = await PrefixService.updatePointCalurate(values)
            setBtnLoading(false)
            toast.success(res.message)
            setActiveKey("2")
            setIsUpdate(true)
            // mutate()
        } catch ({ message }) {
            toast.error(message as string)
            setBtnLoading(false)
        }
    }

    const handleFormSubmit = () => {
        form.validateFields()
            .then((values: any) => {
                setBtnLoading(true)
                updateData(values);
            })
            .catch((errorInfo) => {

            });
    }


    useEffect(() => {
        if (form && dataSetting) {
            form.resetFields();
            form.setFieldsValue({ pointCalcurate: dataSetting?.setting?.point.pointCalcurate })
        }
    }, [form, dataSetting])// eslint-disable-line

    const textCountDeposit = FuncFormattedMessage("setting.features.input.count-deposit", "จำนวนหารยอดฝาก")
    const textPlsCountDeposit = FuncFormattedMessage("setting.features.input.pls-count-deposit", "กรุณากรอกจำนวนหารยอดฝาก")
    const textPlsEnyrtNumberOnly = FuncFormattedMessage("setting.features.input.pls-enter-numbers-only", "กรุณากรอกเป็นตัวเลขเท่านั้น")
    const textPlsEnyrtNumber1_100Only = FuncFormattedMessage("setting.features.input.pls-enter-numbers-1-100", "กรุณากรอกตัวเลขตั้งแต่ 1 - 100 เท่านั้น")
    const textSystemDepositPoints = FuncFormattedMessage("setting.features.input.system-deposit-points", "โดยระบบจะเอา ยอดฝาก หาร ตัวเลขที่กรอกด้านบน = คะแนนสะสม")

    return (
        <Fragment>
            <Form
                form={form}
                name="pointForm"
                layout="vertical"
                hideRequiredMark>
                <Typography.Title level={3}><FormattedMessage id="setting.features.set-points-redeem" defaultMessage="ตั้งค่าสะสมแต้มแลกของรางวัล" /></Typography.Title>
                <Row gutter={16}>
                    <Col span={24}>
                        <Form.Item
                            name="pointCalcurate"
                            label={textCountDeposit}
                            rules={[
                                { required: true, message: textPlsCountDeposit },
                                { pattern: PatternNumber, message: textPlsEnyrtNumberOnly },
                                { type: 'number', min: 1, max: 100, message: textPlsEnyrtNumber1_100Only }
                            ]}
                            hasFeedback
                            extra={textSystemDepositPoints}
                        >
                            <InputNumber placeholder={textCountDeposit} inputMode="numeric" controls={false} />
                        </Form.Item>
                    </Col>
                </Row>
                <Divider />
                <div className="drawer-actions">
                    <Space>
                        <Button type="primary" htmlType="submit" disabled={btnLoading} onClick={handleFormSubmit} size="large"><i className="fa-solid fa-save me-2"></i><FormattedMessage id="setting.features.save" defaultMessage="บันทึก" /> </Button>
                    </Space>
                </div>
            </Form>
        </Fragment>
    )
}

export default Point